import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${tokens.space.sm};
  margin: 1.5rem 0;

  @media (max-width: 1020px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const StatCardWrap = styled.div<{ $active?: boolean; $color: string }>`
  cursor: pointer;
  border-radius: ${tokens.radius.card};
  transition: box-shadow 0.15s ease;
  ${(props) => props.$active && `box-shadow: 0 0 0 1.5px ${props.$color};`}
`

export const GuestCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 1rem;
`

export const GuestCard = styled.div`
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export const GuestHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const GuestName = styled.div`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const GuestMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const GuestId = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const InfoTiles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.625rem;
`

export const InfoTile = styled.div`
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  padding: 0.625rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const Label = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const Value = styled.div`
  font-size: ${tokens.font.body};
  font-weight: 500;
  color: ${tokens.text.primary};
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};

  svg {
    flex: none;
  }
`

export const BreadcrumbBed = styled.span`
  color: ${tokens.accent.base};
  font-weight: 600;
`

export const DurationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.875rem;
  border-top: 1px solid ${tokens.border.hairline};
`

export const DurationLabel = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const DurationValue = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const GuestActions = styled.div`
  display: flex;
  gap: 0.75rem;

  button {
    flex: 1;
  }
`
